import { isError } from "../../../state/helpers/Error"
import HttpClient from "../../../state/helpers/HttpClient"
import SearchResults, { SearchResultDto } from "../../../state/search/Search"
import { SearchPayload } from "../../../state/search/SearchPayload"
import SearchTotals, { SearchTotalsDto } from "../../../state/search/SearchTotals"




class ContactListingService {
    static httpClient: HttpClient<SearchResults,
        SearchResultDto> = new HttpClient<SearchResults, SearchResultDto>(SearchResults)

    static searchTotalsHttpClient: HttpClient<SearchTotals,
        SearchTotalsDto> = new HttpClient<SearchTotals, SearchTotalsDto>(SearchTotals)

    static async listingSearch(searchPayload: SearchPayload): Promise<SearchResults> {
        const res = await this.httpClient.post("/listing/search", searchPayload)

        if (isError(res)) {
            throw new Error(res.message)
        }

        return res as SearchResults
    }

    static async listingSearchTotals(searchPayload : SearchPayload): Promise<SearchTotals> {
        const res = await this.searchTotalsHttpClient.post("/listing/search-totals", searchPayload)

        if (isError(res)) {
            throw new Error(res.message)
        }

        return res as SearchTotals
    }
}

export default ContactListingService


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/ContactListingService.tsx